<template>
  <select-dialog
    :title="$t('CargoMsg.Cargo_SelectOperationInstruction')"
    :row-data="rowData"
    :column-defs="columnDefs"
    :filter-keys="['chineseName']"
    :value="tenantInstruction ? tenantInstruction.uuid : ''"
    :event-name="eventName"
    :input-width="inputWidth"
    display-name-field="chineseName"
    @change="changeTrigger"
  />
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { SE } from '@/class/cargo/model/parameters/SystemConstants'
import { queryAllTenantInstruction } from '@/api/sysManage/baseConfig/instruction'
import SelectDialog from '@/components/SelectDialog'
export default {
  name: 'PlatformInstructionDialog',
  components: { SelectDialog },
  props: {
    lob: {
      type: String,
      default: () => SE.code
    },
    value: {
      type: String,
      default: () => ''
    },
    tagField: { type: String, default: 'uuid' },
    tenantInstructions: { type: Array, default: () => [] }, // 租户操作指令
    inputWidth: {
      type: String,
      default: '250px'
    },
    isApplyUiCustom: { type: Boolean, default: false }, // 是否应用于UI字段配置
    applySopBoard: { type: Boolean, default: false }, // 是否应用于SOP面板
    applyAutoExecute: { type: Boolean, default: false }, // 是否应用于自动化执行
    invokeAutomatedExecution: { type: Boolean, default: false } // 是否应用于调用自动执行
  },
  data() {
    return {
      rowData: [],
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_InstructionType'),
          field: 'instructionType',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.instructionTypeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionCode'),
          field: 'instructionCode',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionChineseName'),
          field: 'chineseName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionEnglishName'),
          field: 'englishName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionJapaneseName'),
          field: 'japaneseName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionDescription'),
          field: 'instructionDescription',
          width: 200
        }
      ],
      tenantInstruction: null,
      eventName: ''
    }
  },
  watch: {
    value() {
      this.init()
    },
    tenantInstructions() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.rowData = []
      this.tenantInstruction = null
      this.eventName = ''
      if (this.tenantInstructions && this.tenantInstructions.length > 0) {
        this.rowData = this.tenantInstructions.filter(p => p.lob === this.lob && ((this.isApplyUiCustom && p.isApplyUiCustom) || (this.applySopBoard && p.applySopBoard) || (this.applyAutoExecute && p.applyAutoExecute)) || (this.invokeAutomatedExecution && p.invokeAutomatedExecution))
        if (this.rowData && this.rowData.length > 0 && this.value) {
          this.tenantInstruction = this.rowData.find(item => item[this.tagField] === this.value)
          if (this.tenantInstruction) {
            this.eventName = this.tenantInstruction.chineseName
          }
        }
      }
    },
    changeTrigger(data) {
      this.tenantInstruction = data
      this.$emit('change', data)
    }
  }
}
</script>
